import { render } from "./UserAvatarUpload.vue?vue&type=template&id=262f7116"
import script from "./UserAvatarUpload.vue?vue&type=script&lang=js"
export * from "./UserAvatarUpload.vue?vue&type=script&lang=js"

import "./UserAvatarUpload.vue?vue&type=style&index=0&id=262f7116&lang=css"
script.render = render

export default script